import React from "react";
import { Link } from "react-router-dom";
function CaseStudyThree() {
  return (
    <div>
      <div className="case-study-section-three">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            {/* Section Heading */}
            <div className="col-12 col-md-6">
              <div className="section-heading text-center">
                <div className="sub-title text-white justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Case Studies
                </div>
                <h2 className="text-white">Explore Latest Case Studies</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="case-studies-masonry lawgis-filter">
            {/* Large Case Study - Takes 2 rows */}
            <div className="case-study-item case-study-large filter-item">
              <Link to="/casestudydetails">
                <div className="case-study-card style-two">
                  <img src="assets/img/bg-img/39.jpg" alt="" />
                  <div className="case-study-content">
                    <div>Property & Real Estate</div>
                    <p className="mb-0">Investment Consulting</p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Regular Cards */}
            <div className="case-study-item filter-item">
              <Link to="/casestudydetails">
                <div className="case-study-card style-two">
                  <img src="assets/img/bg-img/40.jpg" alt="" />
                  <div className="case-study-content">
                    <div>Property & Real Estate</div>
                    <p className="mb-0">Investment Consulting</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="case-study-item filter-item">
              <Link to="/casestudydetails">
                <div className="case-study-card style-two">
                  <img src="assets/img/bg-img/41.jpg" alt="" />
                  <div className="case-study-content">
                    <div>Property & Real Estate</div>
                    <p className="mb-0">Investment Consulting</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="case-study-item filter-item">
              <Link to="/casestudydetails">
                <div className="case-study-card style-two">
                  <img src="assets/img/bg-img/42.jpg" alt="" />
                  <div className="case-study-content">
                    <div>Property & Real Estate</div>
                    <p className="mb-0">Investment Consulting</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="case-study-item filter-item">
              <Link to="/casestudydetails">
                <div className="case-study-card style-two">
                  <img src="assets/img/bg-img/43.jpg" alt="" />
                  <div className="case-study-content">
                    <div>Property & Real Estate</div>
                    <p className="mb-0">Investment Consulting</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="text-center">
            <Link to="/caseStudy" className="btn btn-primary mt-5">
              <span>
                More Case Studies <i className="ti ti-arrow-up-right"></i>
              </span>
              <span>
                More Case Studies <i className="ti ti-arrow-up-right"></i>
              </span>
            </Link>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default CaseStudyThree;
